<template>
  <VFilters
    v-if="!loading"
    :allowed-filters="allowedFilters"
    :filter-groups="filterGroups"
    :default-filters="$route.query.filter || {}"
  />
</template>

<script>
import { teammatesClient } from '@/api/clients';
import VFilters from '@/components/Common/VFilters.vue';

export default {
  name: 'ProjectFilters',
  components: {
    VFilters,
  },
  data() {
    return {
      loading: false,
      ownerOptions: [],
      allowedFilters: {},
      filterGroups: {
        owner: {
          label: 'owner',
          name: 'owner',
          filters: ['has_owner', 'doesnt_have_owner', 'owner_is', 'owner_in', 'owner_not_in'],
          value: null,
        },
        status: {
          label: 'status',
          name: 'status',
          filters: ['has_status', 'doesnt_have_status', 'status_in', 'status_not_in'],
          value: null,
        },
        approval_request_status: {
          label: 'approval request status',
          name: 'approval_request_status',
          filters: ['approval_request_status_in', 'approval_request_status_not_in'],
          value: null,
        },
      },
    };
  },

  async created() {
    try {
      this.loading = true;
      await this.loadOwnerOptions();

      const statusOptions = [
        {
          label: 'Draft',
          value: 'draft',
        },
        {
          label: 'Pending',
          value: 'pending',
        },
        {
          label: 'In progress',
          value: 'in progress',
        },
        {
          label: 'In review',
          value: 'in review',
        },
        {
          label: 'Completed',
          value: 'completed',
        },
        {
          label: 'Cancelled',
          value: 'cancelled',
        },
      ];

      const approvalRequestStatusOptions = [
        {
          label: 'Pending',
          value: 'pending',
        },
        {
          label: 'Approved',
          value: 'approved',
        },
        {
          label: 'Rejected',
          value: 'rejected',
        },
      ];

      this.allowedFilters = {
        has_owner: {
          label: 'with',
          multiple: false,
          name: 'has_owner',
          type: Number,
          value: 1,
        },
        doesnt_have_owner: {
          label: 'without',
          multiple: false,
          name: 'has_owner',
          type: Number,
          value: 0,
        },
        owner_is: {
          label: 'is me',
          multiple: false,
          name: 'owner_is',
          type: String,
          value: this.$user.id,
        },
        owner_in: {
          label: 'is one of ...',
          multiple: true,
          name: 'owner_in',
          options: this.ownerOptions,
          type: String,
          value: [],
        },
        owner_not_in: {
          label: 'is not one of ...',
          multiple: true,
          name: 'owner_not_in',
          options: this.ownerOptions,
          type: String,
          value: [],
        },
        has_status: {
          label: 'with',
          multiple: false,
          name: 'has_status',
          type: Number,
          value: 1,
        },
        doesnt_have_status: {
          label: 'without',
          multiple: false,
          name: 'has_status',
          type: Number,
          value: 0,
        },
        status_in: {
          label: 'is one of ...',
          multiple: true,
          name: 'status_in',
          options: statusOptions,
          type: String,
          value: [],
        },
        status_not_in: {
          label: 'is not one of ...',
          multiple: true,
          name: 'status_not_in',
          options: statusOptions,
          type: String,
          value: [],
        },
        approval_request_status_in: {
          label: 'is one of ...',
          multiple: true,
          name: 'approval_request_status_in',
          options: approvalRequestStatusOptions,
          type: String,
          value: [],
        },
        approval_request_status_not_in: {
          label: 'is not one of ...',
          multiple: true,
          name: 'approval_request_status_not_in',
          options: approvalRequestStatusOptions,
          type: String,
          value: [],
        },
      };
    } catch (error) {
      //
    } finally {
      this.loading = false;
    }
  },

  methods: {
    async loadOwnerOptions() {
      try {
        const result = await teammatesClient.list({
          params: {
            filter: {
              owns_project: 1,
            },
          },
        });

        this.setOwnerOptions(result.data.data);
      } catch (error) {
        //
      }
    },
    setOwnerOptions(users) {
      this.ownerOptions = users.map((user) => ({
        label: user.id === this.$user.id ? 'Me' : user.fullName,
        value: user.id,
      }));
    },
  },
};
</script>
